import {
  SET_EXCHANGE_RATE,
  SET_CLASSIFY_LIST,
  SET_BRAND_LIST,
  SET_POPULARITY_BRANDS_INIT,
  SET_POPULARITY_BRANDS
} from "@/store/mutation-types";
import classify from "@/basejson/classify";
import brand from "@/basejson/brand";
import api from "@/api";
import Vue from "vue";
import { xjp_oos_domain } from "../../utils/common";

import ChinaAds from "@/basejson/China";
import AusAds from "@/basejson/Australia";
import MalaysiaAds from "@/basejson/Malaysia";
import TaiwanAds from "@/basejson/TaiWan";
import countryDateCode from "@/basejson/countryDateCode";
const state = {
  //首先初始化
  exchangeRate: 5, //人民币 澳币汇率
  classifyList: classify.classify.data,
  brandList: brand.brand.data,
  // pickupShopList: ['caning vale', 'young health', 'assicess sss'],
  logisticList: [],
  //订单页后初始化
  postTypeList: [],
  payTypeList: [
    {
      payName: "RoyalPayCard",
      payCode: "RoyalPayCard",
      payType: "5",
      img: xjp_oos_domain + "/pc-en/img/pay_royal_card.jpg"
    },
    {
      payName: "Paypal",
      payCode: "Paypal",
      payType: "PayPal",
      img: xjp_oos_domain + "/pc-en/img/pay_paypal.jpg"
    },
    {
      payName: "Poli",
      payCode: "Poli",
      payType: "3",
      img: xjp_oos_domain + "/pc-en/img/pay_poli.jpg"
    },
    {
      payName: "Wechet",
      payCode: "wechet",
      payType: "2",
      img: xjp_oos_domain + "/pc-en/img/pay_wechet.jpg"
    },
    {
      payName: "Ali",
      payCode: "ali",
      payType: "4",
      img: xjp_oos_domain + "/pc-en/img/pay_ali.jpg"
    },
    {
      payName: "OffLine Transfer",
      payCode: "OffLine Transfer",
      payType: "transfer",
      img: xjp_oos_domain + "/pc-en/img/pay_tra.jpg",
      rem: "BSB:086-006 ACC:30-991-7968"
    },
    {
      payName: "联系客服支付",
      payCode: "联系客服支付",
      payType: "1",
      img: xjp_oos_domain + "/pc-en/img/pay_server.jpg"
    },
    {
      payName: "Pre-deposit",
      payCode: "Pre-deposit",
      payType: "0",
      img: xjp_oos_domain + "/pc-en/img/pay_aws.jpg"
    },
    {
      payName: "货到付款",
      payCode: "货到付款",
      payType: "cashOnDelivery",
      img: xjp_oos_domain + "/pc-en/img/pay_server.jpg"
    }
  ],
  //带图片品牌页
  popularityBrandsInit: false,
  popularityBrands: [],

  //create order/create address init
  countryDateCode: countryDateCode.data,
  ChinaAds: ChinaAds.data,
  AusAds: AusAds.data,
  MalaysiaAds: MalaysiaAds.data,
  TaiWanAds: TaiwanAds.data
};
const mutations = {
  [SET_EXCHANGE_RATE](state, exchangeRate) {
    state.exchangeRate = exchangeRate;
  },
  [SET_CLASSIFY_LIST](state, classifyList) {
    // state.classifyList = classifyList   s
    Vue.set(state, "classifyList", classifyList);
  },
  [SET_BRAND_LIST](state, brandList) {
    brandList.sort((x, y) => {
      if (x.checked < y.checked) {
        return 1;
      } else if (x.checked > y.checked) {
        return -1;
      } else {
        return 0;
      }
    });
    Vue.set(state, "brandList", brandList);
  },
  [SET_POPULARITY_BRANDS_INIT](state, popularityBrandsInit = true) {
    Vue.set(state, "popularityBrandsInit", popularityBrandsInit);
  },
  [SET_POPULARITY_BRANDS](state, popularityBrands) {
    Vue.set(state, "popularityBrands", popularityBrands);
  }
};
const actions = {
  getRealExchangeRate({ commit }) {
    api.common.getExchangeRate().then(
      res => {
        const { result } = res;
        commit(SET_EXCHANGE_RATE, result);
      },
      err => {
        //do something
        console.log(err);
      }
    );
  },
  getRealBrandList({ commit }) {
    api.common.getBrandList().then(
      res => {
        const { result } = res;
        commit(SET_BRAND_LIST, result);
      },
      err => {
        //do something
        console.log(err);
      }
    );
  },
  getRealclassifyList({ commit }) {
    api.common.getClassifyList().then(
      res => {
        const { result } = res;
        commit(SET_CLASSIFY_LIST, result);
      },
      err => {
        //do something
        console.log(err);
      }
    );
  },
  popularityBrandInit({ commit, state }) {
    if (!state.popularityBrandsInit) {
      api.common
        .popularityBrand()
        .then(res => {
          let { result } = res;
          commit(SET_POPULARITY_BRANDS_INIT, true);
          commit(SET_POPULARITY_BRANDS, result);
        })
        .catch(err => err);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js